import moment from 'moment';

/**
 * Is this a string with some content
 * Must not be null, '' or any other falsey value and have some length
 *
 * @param {string} value
 *
 * @return {boolean}
 */
export const stringRequired = (value) => !!(isScalar(value) && value !== '' && ( (value && value.trim ? value.trim() : value)  !== ''));

/**
 * Is scalar
 *
 * @param {string} value
 *
 * @return {boolean}
 */
export const isScalar = (value) => !!(value !== null && typeof value !== 'undefined');

/**
 * Create a moment value of a standard date str.
 *
 * @param {string} value the date str as 'DD/MM/YYYY'
 *
 * @return {boolean}
 */
export const mDate = value => moment(value, 'DD/MM/YYYY');

/**
 * Is a date str valid, is it a valid string is it in the format DD/MM/YYYY and a valid date
 *
 * @param {string} value the date str as 'DD/MM/YYYY'
 *
 * @return {boolean}
 */
export const validDate = value => stringRequired(value) && /^[0123][0-9]\/[01][0-9]\/[12][09][0-9]{2}$/.test(value) && mDate(value).isValid();

/**
 * Object to define validations by vue js el types.
 */
export default {
    text: {
        // Required string
        required: stringRequired,
        // Is the length of the string greater than a given value
        min: (value, opt) => !stringRequired(value) ? true : value.length >= parseInt(opt, 10),
        // Is the length less than a specific length
        max: (value, opt) => !stringRequired(value) ? true : value.length <= parseInt(opt, 10),
        // Use same name validation regex as back-end
        name: value => !stringRequired(value) || /^(?=.*)[\x20-\xFE]+$/g.test(value)
    },
    number: {
        // Valid Number
        valid: value => !isNaN(value),
        // Turn to string and test for required
        required: value => isScalar(value) && stringRequired(value.toString()) && !isNaN(value),
        // Check value is greater than value
        min: (value, opt) => isScalar(value) && !stringRequired(value.toString()) ? true : parseFloat(value) >= parseFloat(opt),
        // Check value is less than value
        max: (value, opt) => isScalar(value) && !stringRequired(value.toString()) ? true : parseFloat(value) <= parseFloat(opt),
    },
    date: {
        // Date valid
        required: value => validDate(value),
        // Date is greater than another date string
        min: (value, opt) => !validDate(value) || !validDate(opt) ? true : mDate(value).isSameOrAfter(mDate(opt)),
        // Date is less than another date string
        max: (value, opt) => !validDate(value) || !validDate(opt) ? true : mDate(value).isSameOrBefore(mDate(opt)),
    },
    'select-one': {
        // Test as string
        required: stringRequired,
        // Always true
        min: true,
        // Always true
        max: true,
    },
    array: {
        // Does the array have length
        required: value => !!value.length,
    }
};



// WEBPACK FOOTER //
// ./src/components/form/validator/validations.js